import { useState } from "react";
import { Lifebuoy, Rocket, BookOpen, ChatCircleDots } from "@phosphor-icons/react";
import { useRole } from "@/hooks/useRole";
import { OnboardingWizard } from "@/components/OnboardingWizard";
import { HelpCenter } from "@/components/HelpCenter";
import { AskShee } from "@/components/AskShee";

const TABS = [
  { k: "start", label: "Getting Started", icon: Rocket },
  { k: "manual", label: "Help Center", icon: BookOpen },
  { k: "ask", label: "Ask Shee", icon: ChatCircleDots },
];

export default function Help() {
  const { role } = useRole();
  const [tab, setTab] = useState("start");

  return (
    <div className="space-y-6 max-w-5xl" data-testid="help-page">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-[12px] bg-[#5FA8B4] flex items-center justify-center text-white shrink-0">
          <Lifebuoy size={22} weight="fill" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-[#3C4048] tracking-tight" style={{ fontFamily: "Montserrat", fontWeight: 800 }}>Help & Getting Started</h1>
          <p className="text-[#55666b] text-sm">Learn the app, work through your setup, or just ask Shee.</p>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-wrap" data-testid="help-tabs">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button key={t.k} onClick={() => setTab(t.k)} data-testid={`help-tab-${t.k}`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${tab === t.k ? "bg-[#3A7A8C] text-white border-[#3A7A8C]" : "bg-white text-[#3C4048] border-[#e5e7eb] hover:border-[#5FA8B4]"}`}>
              <Icon size={16} weight={tab === t.k ? "fill" : "regular"} /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === "start" && <OnboardingWizard role={role} />}
      {tab === "manual" && <HelpCenter role={role} />}
      {tab === "ask" && <AskShee />}
    </div>
  );
}
